<template>

    <v-step :step="step" title="Goal">

        <v-form-group label="Goal Type" caption="How the customer completes the goal.">
            <v-selector class="w-500" :model="goal.type" @input="setGoalType($event)" :items="[
                { value: '', title: 'Select Goal Type' },
                { value: 'event', title: 'Performed an event', desc: 'The goal is met when a customer performs an event.' },
                { value: 'page', title: 'Visited a page', desc: 'The goal is met when a customer visits a page.' },
                { value: 'segment-enter', title: 'Entered a segment', desc: 'The goal is met when a customer enters a segment.' },
                { value: 'segment-exit', title: 'Exited a segment', desc: 'The goal is met when a customer exits a segment.' },
                { value: 'tag-add', title: 'Tag Added', desc: 'The goal is met when a customer is tagged.' },
                { value: 'tag-remove', title: 'Tag Removed', desc: 'The goal is met when a customer is untagged.' },
                { value: 'form-submitted', title: 'Form Submitted', desc: 'The goal is met when a customer submits a form.' },
            ]" />
        </v-form-group>

        <v-form-group v-if="['segment-enter', 'segment-exit'].includes(goal.type)" label="Segment" caption="The segment for the goal.">
            <v-selector class="w-500" :model="goal.segment_id" @input="setSegment($event)" :items="segments | segmentsForSelector" searchable />
        </v-form-group>

        <v-form-group v-if="['tag-add', 'tag-remove'].includes(goal.type)" label="Tag" caption="The tag for the goal.">
            <v-selector class="w-500" :model="goal.tag_id" @input="setTag($event)" :items="tags | tagsForSelector" searchable />
        </v-form-group>

        <v-form-group v-if="['form-submitted'].includes(trigger.type)" label="Form" caption="The form for the goal.">
            <v-selector class="w-500" :model="trigger.form_id" @input="setForm($event)" :items="forms | formsForSelector" searchable />
        </v-form-group>

        <v-form-group v-if="goal.type === 'event'" label="Event" caption="The event for the goal.">
            <v-selector class="w-500" :model="goal.event_id" @input="setEvent($event)" :items="events | eventsForSelector" searchable />
            <div v-if="selectedEvent && selectedEvent.properties.length" class="mt-10">
                <v-segmenter-event :model="goal" />
            </div>
        </v-form-group>

        <v-form-group v-if="goal.type === 'page'" label="Page" caption="The page for the goal.">
            <v-segmenter-page :model="goal" />
        </v-form-group>

        <v-form-group v-if="goal.type" label="Timeframe" caption="How long the customer has to complete the goal after entering the automation.">
            <v-delay-picker class="w-500" :model="goal.timeframe" @input="setParam({ timeframe : $event })" />
        </v-form-group>

    </v-step>

</template>

<script>

import Step from './Step';

export default {

    components: {
        'v-step': Step,
    },

    props: {
        step: {
            type: Number,
            default: 1,
        },
    },

    computed: {

        campaign() {
            return this.$store.getters['campaign/campaign'];
        },

        goal() {
            return this.campaign.goal;
        },

        segments() {
            return this.$store.getters.project.segments;
        },

        events() {
            return this.$store.getters.project.events;
        },

        tags() {
            return this.$store.getters.project.tags;
        },

        forms() {
            return this.$store.getters.project.forms;
        },

        selectedEvent() {
            if (this.goal.event_id) {
                return this.events.find(e => e.id === this.goal.event_id);
            }
            return null;
        },

    },

    methods: {

        setGoalType(val) {
            let goal = { ...this.goal };
            goal.type = val;
            goal.segment_id = null;
            goal.event_id = null;
            goal.tag_id = null;
            goal.form_id = null;
            goal.rules = [];
            this.$store.commit('campaign/setParam', { goal: goal });
            this.$store.commit('segmenter/setRules', goal.rules);
        },

        setSegment(id) {
            let goal = { ...this.goal };
            goal.segment_id = id;
            goal.event_id = null;
            goal.tag_id = null;
            goal.form_id = null;
            goal.rules = [];
            this.$store.commit('campaign/setParam', { goal: goal });
            this.$store.commit('segmenter/setRules', goal.rules);
        },

        setEvent(id) {
            let goal = { ...this.goal };
            goal.segment_id = null;
            goal.event_id = id;
            goal.tag_id = null;
            goal.form_id = null;
            goal.rules = [];
            this.$store.commit('campaign/setParam', { goal: goal });
            this.$store.commit('segmenter/setRules', goal.rules);
        },

        setTag(id) {
            let goal = { ...this.goal };
            goal.segment_id = null;
            goal.event_id = null;
            goal.tag_id = id;
            goal.form_id = null;
            goal.rules = [];
            this.$store.commit('campaign/setParam', { goal: goal });
            this.$store.commit('segmenter/setRules', goal.rules);
        },

        setForm(id) {
            let goal = { ...this.goal };
            goal.segment_id = null;
            goal.event_id = null;
            goal.tag_id = null;
            goal.form_id = id;
            goal.rules = [];
            this.$store.commit('campaign/setParam', { goal: goal });
            this.$store.commit('segmenter/setRules', goal.rules);
        },

        setParam(param) {
            let goal = { ...this.goal };
            let key = Object.keys(param)[0];
            goal[key] = param[key];
            this.$store.commit('campaign/setParam', { goal: goal });
        },

    },

}

</script>
